import { CloudDownload } from 'lucide-react';
import { useNavigate } from 'react-router';

import { useConsultarChave } from '@/lib/captura/api';
import { avisarConsultaChave } from '@/lib/captura/avisos';
import { mensagemErroCaptura } from '@/lib/captura/textos';
import { BotaoCopiar } from '@/ui/components/copiar';
import { toast } from '@/ui/primitives/aviso';
import { Button } from '@/ui/primitives/button';
import { type ChavePendente } from '@fiscoai/contracts';

/** Busca a nota da linha na SEFAZ (consChNFe) como a empresa da chave; o resultado vira toast. */
function BuscarNaSefaz({ chave, numero }: { chave: ChavePendente; numero: string }) {
  const consultar = useConsultarChave(chave.empresaId);
  const navegar = useNavigate();
  return (
    <Button
      tamanho="sm"
      variante="fantasma"
      carregando={consultar.isPending}
      aria-label={`Buscar na SEFAZ a nota ${numero}`}
      onClick={() => {
        consultar.mutate(chave.chave, {
          onSuccess: (r) => {
            avisarConsultaChave(r, (rota) => void navegar(rota));
          },
          // Sem o estado da captura aqui: o `detail` do 409 já vem com a hora da instalação.
          onError: (erro) => toast.error(mensagemErroCaptura(erro, null)),
        });
      }}
    >
      {!consultar.isPending && <CloudDownload aria-hidden />}
      Buscar na SEFAZ
    </Button>
  );
}

/** Ações da linha: copiar a chave e, para quem executa a captura, buscar a nota na SEFAZ. */
export function AcoesChave({ chave, podeBuscar }: { chave: ChavePendente; podeBuscar: boolean }) {
  const numero = String(Number(chave.numero));
  return (
    <span className="inline-flex items-center gap-1">
      {podeBuscar && chave.status === 'PENDENTE' && <BuscarNaSefaz chave={chave} numero={numero} />}
      <BotaoCopiar texto={chave.chave} rotulo={`Copiar chave da nota ${numero}`} />
    </span>
  );
}
